import { Dispatch, FC, SetStateAction, useEffect, useMemo, useState } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import { DashboardGetStudentExitSlipQuery } from '../../graphQLOperations/__generated__/DashboardGetStudentExitSlipQuery.graphql';
import { getStudentExitSlip } from '../../graphQLOperations/Dashboard';
import { getStudentPendingExitSlips } from '../../businessLogicService/studentPendingExitSlips';
import DashboardExitSlipBanner from './DashboardExitSlipBanner';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import {
  selectedExitSlipStudentFinished,
  setExitSlipStudentFinished,
} from '../../redux/reducers/exitSlipStudentFinishedSlice';

interface Props {
  queryReferenceExitSlip?: PreloadedQuery<DashboardGetStudentExitSlipQuery, Record<string, unknown>>;
  setSkillIdForRefresherCard: Dispatch<SetStateAction<string | null>>;
}
const DashboardExitSlipQuery: FC<Props> = ({ queryReferenceExitSlip, setSkillIdForRefresherCard }) => {
  const dispatch = useAppDispatch();
  const exitSlipFinishedRedux = useAppSelector(selectedExitSlipStudentFinished);
  const [currentIndex, setCurrentIndex] = useState<number>(0);

  const queryData = usePreloadedQuery<DashboardGetStudentExitSlipQuery>(
    getStudentExitSlip,
    queryReferenceExitSlip as PreloadedQuery<DashboardGetStudentExitSlipQuery>,
  );

  const pendingExitSlips = useMemo(() => getStudentPendingExitSlips(queryData.classExitSlips), [queryData]);
  const currentExitSlip = pendingExitSlips[currentIndex] ?? null;

  useEffect(() => {
    if (!exitSlipFinishedRedux) return;
    setCurrentIndex(index => index + 1);
    dispatch(setExitSlipStudentFinished(false));
  }, [exitSlipFinishedRedux]);

  useEffect(() => {
    setSkillIdForRefresherCard(currentExitSlip?.curriculumLesson.skill?.id ?? null);
  }, [currentExitSlip]);

  return (
    currentExitSlip && (
      <div
        className="tw-flex tw-w-full tw-right-[0] lg:tw-right-[unset] lg:tw-w-4/5 tw-fixed tw-z-30 tw-justify-center tw-pointer-events-none"
        style={{ bottom: '70px' }}
      >
        <DashboardExitSlipBanner exitSlipsData={currentExitSlip} />
      </div>
    )
  );
};

export default DashboardExitSlipQuery;
